import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Chip } from "@material-tailwind/react";
import { useAuth } from '../../AuthContext';
import SearchableSelect from '../../../common/SearchableSelect';

const OwnerFilter = ({ selectedOwner, onOwnerChange, className = "" }) => {
    const { rootUrl } = require('../../../../config/config');
    const { token } = useAuth();
    const [owners, setOwners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchOwners = async () => {
            try {
                const response = await axios.get(`${rootUrl}/owners`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setOwners(response.data);
            } catch (error) {
                console.error('Error fetching owners:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchOwners();
    }, [rootUrl, token]);

    const getSelectedOwnerName = () => {
        if (!selectedOwner) return null;
        const owner = owners.find(o => o.code === selectedOwner);
        return owner ? owner.name : selectedOwner;
    };

    const clearFilter = () => {
        onOwnerChange(null);
    };

    if (loading) {
        return (
            <div className={`space-y-2 ${className}`}>
                <Typography variant="small" color="blue-gray" className="font-medium">
                    Filter by Owner
                </Typography>
                <div className="animate-pulse bg-gray-200 h-10 rounded-lg"></div>
            </div>
        );
    }

    return (
        <div className={`space-y-2 ${className}`}>
            <div className="flex items-center justify-between">
                <Typography variant="small" color="blue-gray" className="font-medium">
                    Filter by Owner
                </Typography>
                {selectedOwner && (
                    <button
                        onClick={clearFilter}
                        className="text-xs text-blue-600 hover:text-blue-800"
                    >
                        Clear
                    </button>
                )}
            </div>

            <SearchableSelect
                placeholder="All Owners"
                value={selectedOwner}
                onChange={(value) => onOwnerChange(value || null)}
                loading={loading}
                options={[
                    { value: '', label: 'All Owners' },
                    ...owners.map(owner => ({
                        value: owner.code,
                        label: `${owner.name} (${owner.code})`
                    }))
                ]}
                className="bg-white"
            />

            {selectedOwner && (
                <Chip
                    size="sm"
                    variant="filled"
                    color="blue"
                    value={`Selected: ${getSelectedOwnerName()}`}
                    className="w-fit"
                    onClose={clearFilter}
                />
            )}
        </div>
    );
};

export default OwnerFilter;
